import React, { useState, useEffect, useRef } from 'react';
import { Check, X } from 'lucide-react';

const InlineRenameInput = ({ 
  initialValue, 
  onConfirm, 
  onCancel,
  placeholder = "Enter name...",
  className = "",
  inputClassName = ""
}) => {
  const [value, setValue] = useState(initialValue || '');
  const [loading, setLoading] = useState(false);
  const inputRef = useRef(null);

  // Focus input when component mounts
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, []);

  const handleConfirm = async () => {
    if (!value.trim()) {
      onCancel?.();
      return;
    }

    if (value.trim() === initialValue) {
      onCancel?.();
      return;
    }

    try {
      setLoading(true);
      await onConfirm?.(value.trim());
    } catch (error) {
      console.error('Error confirming rename:', error);
      // Don't auto-cancel on error, let user try again
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleConfirm();
    } else if (e.key === 'Escape') {
      onCancel?.();
    }
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <input
        ref={inputRef}
        type="text"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={handleKeyPress}
        placeholder={placeholder}
        className={`flex-1 bg-transparent border border-blue-500 rounded px-2 py-1 text-slate-100 text-sm font-semibold focus:outline-none focus:ring-2 focus:ring-blue-500/50 ${inputClassName}`}
        disabled={loading}
      />
      <div className="flex gap-1">
        <button
          onClick={handleConfirm}
          disabled={loading || !value.trim()}
          className="p-1 bg-green-600 hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed rounded text-white transition-colors"
          title="Confirm rename"
        >
          {loading ? (
            <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-white"></div>
          ) : (
            <Check size={12} />
          )}
        </button>
        <button
          onClick={onCancel}
          disabled={loading}
          className="p-1 bg-red-600 hover:bg-red-700 disabled:opacity-50 rounded text-white transition-colors"
          title="Cancel"
        >
          <X size={12} />
        </button>
      </div>
    </div>
  );
};

export default InlineRenameInput;